const PrivaceSection = () => {
  return (
    <section className="pf-terms-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="pf-terms-wrap">
              <div className="pf-terms-text">
                <h2>1. Introduction</h2>
                <p>
                  Welcome to JSA Online, your trusted partner for Cash Flow Management Services. At JSA Online, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect the information you provide when using our services.
                </p>

                <h2>2. Information We Collect</h2>
                <p><strong>2.1. Personal Information:</strong> We may collect personal information such as your name, contact information, financial data, and other information necessary for the provision of our services.</p>
                <p><strong>2.2. Usage Data:</strong> We may collect information about your use of our services, including but not limited to, IP addresses, browser types, and operating systems.</p>

                <h2>3. How We Use Your Information</h2>
                <p><strong>3.1. Service Provision:</strong> We use your personal information to provide you with our Cash Flow Management Services, including but not limited to financial analysis and reporting.</p>
                <p><strong>3.2. Communication:</strong> We may use your contact information to communicate with you about your account, service updates, and promotional offers.</p>
                <p><strong>3.3. Legal Compliance:</strong> We may use your information to comply with legal obligations, resolve disputes, and enforce our policies.</p>

                <h2>4. Disclosure of Information</h2>
                <p>
                  We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except for the purposes of providing the services you have requested or as required by law.
                </p>

                <h2>5. Security</h2>
                <p>
                  We employ security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction.
                </p>

                <h2>6. Cookies and Tracking Technologies</h2>
                <p>
                  We use cookies and similar tracking technologies to enhance your experience and collect information about your use of our website. You can manage your cookie preferences through your browser settings.
                </p>

                <h2>7. Your Rights</h2>
                <p>
                  You have the right to access, correct, or delete your personal information. If you have any questions or requests regarding your data, please contact us at <a href="mailto:sales@jsa.net.in">sales@jsa.net.in</a>.
                </p>

                <h2>8. Changes to this Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. The revised policy will be posted on our website.
                </p>

                <h2>9. Contact Us</h2>
                <p>
                  If you have any questions or concerns about our Privacy Policy or how we handle your data, please contact us at <a href="mailto:sales@jsa.net.in">sales@jsa.net.in</a>.
                </p>
                <p>
                  <strong>Mr. Jagmohan Singh</strong><br />
                  (Grievance Officer)<br />
                  <a href="http://jsa.net.in" target="_blank" rel="noopener noreferrer">http://jsa.net.in</a><br />
                  Jagmohan Singh &amp; Associates<br />
                  Email: <a href="mailto:mail@jsa.net.in">mail@jsa.net.in</a><br />
                  Ph: +011-41588008
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PrivaceSection;
